export default "__VITE_ASSET__BfzM6_ln__"